import { Dashboard } from '~/javascripts/dashboard';

class UnitDistributionByIntegrationType {
  constructor() {
    this.data = null;
  }

  static create() {
    const instance = new UnitDistributionByIntegrationType();
    return {
      setData: instance.setData.bind(instance),
      renderChart: instance.renderChart.bind(instance),
    };
  }

  setData(value) {
    this.data = value;
  }

  renderChart() {
    const canvas = document.getElementById('unit-distribution-chart');
    if (!canvas || !this.data || this.data.length === 0) return;

    const ctx = canvas.getContext('2d');
    const labels = [];
    const values = [];

    this.data.forEach((item) => {
      labels.push(`${item[0]} - ${item[1]}`);
      values.push(item[1]);
    });

    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            label: 'Unit distribution by Integration Type',
            data: values,
            backgroundColor: [
              'rgba(0, 104, 229, 1)',
              'rgba(10, 217, 225, 1)',
              'rgba(121, 20, 239,1)',
              'rgba(219, 105, 255, 1)',
              'rgba(254, 144,	48, 1)',
              'rgba(255, 224,	46, 1)',
              'rgba(239, 10, 54, 1)',
              'rgba(255, 151,	138, 1)',
              'rgba(28, 156, 126, 1)',
              'rgba(16, 86, 70, 1)',
              'rgb(179, 179, 179)',
              'rgb(56, 56, 56)',
              'rgb(99, 70, 70)',
            ],
            borderColor: [
              'rgba(0, 104, 229, 1)',
              'rgba(10, 217, 225, 1)',
              'rgba(121, 20, 239,1)',
              'rgba(219, 105,	255, 1)',
              'rgba(254, 144,	48, 1)',
              'rgba(255, 224,	46, 1)',
              'rgba(239, 10, 54, 1)',
              'rgba(255, 151,	138, 1)',
              'rgba(28, 156, 126, 1)',
              'rgba(16, 86, 70, 1)',
              'rgb(179, 179, 179)',
              'rgb(56, 56, 56)',
              'rgb(99, 70, 70)',
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'right' },
        },
      },
    });
  }
}

Dashboard.unitDistributionByIntegrationType = UnitDistributionByIntegrationType.create();
